import React from 'react';
import { Box } from '@mui/material';
import { Views } from 'react-big-calendar';
import { CalendarEventsPeriod } from '@trnsact/trnsact-shared-types';

import { MonthPanel } from './MonthPanel';
import { CalendarMapper } from '../../mapper';
import { CalendarView, CalendarViewComponentProps } from '../../types';
import { Calendar, CalendarConnector, CalendarEventCard } from '../calendar';

export const MonthCalendar = ({ date, onNavigate }: CalendarViewComponentProps) => (
  <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 20rem', gap: '0.5rem', height: '100%' }}>
    <CalendarConnector
      period={CalendarEventsPeriod.Month}
      dateRange={CalendarMapper.getVisibleRange(CalendarView.Month, date)}
      children={props => (
        <Calendar
          step={10}
          timeslots={6}
          date={date}
          view={Views.MONTH}
          views={[Views.MONTH]}
          onNavigate={onNavigate}
          components={{
            event: props => <CalendarEventCard {...props} />,
          }}
          {...props}
        />
      )}
    />

    <MonthPanel />
  </Box>
);
